export default {
  activeApproval: ({ configurations }) => configurations.activeApproval,
  activeCohort: ({ cohorts }) => cohorts.activeCohort,
  activeCollection: ({ collections }) => collections.activeCollection,
  activeDatasourceSettings: ({ datasetDatasource }) => datasetDatasource.activeDatasourceSetting,
  activeDataset: ({ datasets }) => datasets.activeDataset,
  activeDatasetCondition: ({ datasetConditions }) => datasetConditions.activeCondition,
  activeRequestTask: ({ requests }) => requests.tasks.activeTask,
  activeRole: ({ roles }) => roles.activeRole,
  activeRoleActions: ({ roles }) => roles.activeRoleActions,
  activeSearch: ({ search }) => search.activeSearch,
  activeTheme: ({ themes }) => themes.activeTheme,
  activeToken: ({ tokens }) => tokens.activeToken,
  activeUserGroup: ({ userGroups }) => userGroups.activeUserGroup,
  activeVocabulary: ({ vocabularies }) => vocabularies.activeVocabulary,
  audits: ({ audit }) => audit.audits,
  auth: ({ auth }) => auth,
  catalogueTemplates: ({ catalogues }) => catalogues.templates,
  catalogues: ({ catalogues }) => catalogues.catalogues,
  collectionAssigningDataset: ({ datasetCollections }) => datasetCollections.collectionAssigningDataset,
  collectionDatasets: ({ collectionDatasets }) => collectionDatasets.collectionDatasets,
  collections: ({ collections }) => collections.collections,
  configurations: ({ configurations }) => configurations.configurations,
  cohorts: ({ cohorts }) => cohorts.cohorts,
  datasetAssigningCollection: ({ collectionDatasets }) => collectionDatasets.datasetAssigningCollection,
  datasetCollections: ({ datasetCollections }) => datasetCollections.datasetCollections,
  datasetConditions: ({ datasetConditions }) => datasetConditions.datasetConditions,
  datasetMetrics: ({ datasetMetrics }) => datasetMetrics.datasetMetrics,
  datasetNotification: ({ datasetNotifications }) => datasetNotifications.datasetNotification,
  datasetSettings: ({ datasetSettings }) => datasetSettings.settings,
  datasourceSettings: ({ datasetDatasource }) => datasetDatasource.settings,
  datasets: ({ datasets }) => datasets.datasets,
  manageRequestTask: ({ requests }) => requests.tasks.manageTask,
  notifications: ({ notifications }) => notifications.notifications,
  requests: ({ requests }) => requests.requests,
  requestTasks: ({ requests }) => requests.tasks,
  requestTaskViews: ({ requests }) => requests.tasks.views,
  role: ({ auth }) => auth.role,
  roles: ({ roles }) => roles.roles,
  searchConfig: ({ search }) => search.searchConfig,
  searches: ({ search }) => search.searches,
  sharingCohort: ({ cohorts }) => cohorts.sharingCohort,
  sharingCollection: ({ collections }) => collections.sharingCollection,
  sharingDataset: ({ datasetUsers }) => datasetUsers.sharingDataset,
  sharingSearch: ({ search }) => search.sharingSearch,
  subscribers: ({ notifications }) => notifications.subscribers,
  subscriptions: ({ notifications }) => notifications.subscriptions,
  taskTemplates: ({ requests }) => requests.tasks.templates,
  themes: ({ themes }) => themes.themes,
  tokens: ({ tokens }) => tokens.tokens,
  userGroups: ({ userGroups }) => userGroups.userGroups,
  users: ({ auth }) => auth.users,
  usersGroups: ({ auth }) => auth.userGroups,
  vocabularies: ({ vocabularies }) => vocabularies.vocabularies,
  workflows: ({ workflows }) => workflows.workflows,
  workspaceForms: ({ workspaces }) => workspaces.forms,
};
